import type { Airflow, Dict } from '@aviata/platform-types';
import dayjs from 'dayjs';

import { dictEntity, dateUtils } from 'shared'; // TODO: Is it ok to use entity inside other entity. It seems ok since this is because of business logic

const mapSegmentPoint = (dict: Dict.Entity, point: Airflow.Segment.Point) => {
  /** Need to remove timezone to date stay in initial time zone after parsing */
  const timeWithoutTimeZone = dateUtils.removeTimezone(point.at);
  return {
    ...point,
    airportText: dictEntity.lib.getAirport(point.airport, dict).name,
    city: dictEntity.lib.getCityByAirport(point.airport, dict).name,
    time: dateUtils.prettyTime(timeWithoutTimeZone),
    dayOfMonth: dateUtils.getVerbalDate(timeWithoutTimeZone),
    formattedDate: dateUtils.format(timeWithoutTimeZone, 'D MMMM'),
    dayOfWeek: dateUtils.format(timeWithoutTimeZone, 'dd'),
    year: dateUtils.format(timeWithoutTimeZone, 'YYYY'),
    iso: point.at,
  };
};

const mapLocation = (
  dict: Dict.Entity,
  location: Airflow.Segment.StopLocation,
) => {
  const arrAt = new Date(location.arr_at);
  const depAt = new Date(location.dep_at);
  const durationInSeconds = (depAt.getTime() - arrAt.getTime()) / 1000;
  const duration = dateUtils.prettyDurationFromSeconds(durationInSeconds);

  return {
    ...location,
    airportText: dictEntity.lib.getAirport(location.airport, dict).name,
    city: dictEntity.lib.getCityByAirport(location.airport, dict).name,
    duration,
  };
};

export const mapSegment = (
  dict: Dict.Entity,
  segment: Airflow.Segment.Entity,
  segmentsCount?: number,
) => {
  const durationSeconds = dayjs(segment.arr.at).diff(
    dayjs(segment.dep.at),
    'second',
  );

  const durationTxt = dateUtils.prettyDurationFromSeconds(
    durationSeconds,
    true,
  );

  return {
    ...segment,
    dep: mapSegmentPoint(dict, segment.dep),
    arr: mapSegmentPoint(dict, segment.arr),
    flightNumber: segment.flight_number,
    handLuggage: segment.hand_luggage,
    displayAirline: segment.display_airline,
    airlineTitle: dictEntity.lib.getAirline(segment.display_airline, dict).name,
    ...(segmentsCount && segmentsCount > 1 && { durationTxt }),
    stops: {
      ...segment.stops,
      locations:
        segment.stops.locations?.map(location => mapLocation(dict, location)) ||
        null,
    },
  };
};

export function mapFlight(dict: Dict.Entity, flight: Airflow.Offer.Flight) {
  const segmentsCount = flight.segments.length;
  return {
    duration: flight.duration,
    durationText: dateUtils.prettyDurationFromSeconds(flight.duration, true),
    segments: flight.segments.map(segment =>
      mapSegment(dict, segment, segmentsCount),
    ),
  };
}
